import { render, staticRenderFns } from "./jurnalumum.vue?vue&type=template&id=92fbddc0&scoped=true"
import script from "./jurnalumum.vue?vue&type=script&lang=js"
export * from "./jurnalumum.vue?vue&type=script&lang=js"
import style0 from "./jurnalumum.vue?vue&type=style&index=0&id=92fbddc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92fbddc0",
  null
  
)

export default component.exports